import { redirect } from "react-router-dom";
import { deleteInvestment } from "../../../data/money/investments";

export async function action({ params }) {
    await deleteInvestment(params.investmentId);
    return redirect(`/sources/${params.sourceId}`);
}